export default class Action {
  icon = null

  onClick = null

  tooltip = null

  constructor(icon, tooltip, onClick, props) {
    this.icon = icon
    this.tooltip = tooltip
    this.onClick = onClick
    this.initProps(props || {})
  }

  initProps({ ...props }) {
    for (const key in props) {
      if (Object.prototype.hasOwnProperty.call(props, key)) {
        this[key] = props[key]
      }
    }
  }
}
